// extracted by mini-css-extract-plugin
module.exports = {"blockValue":"BlockValue_blockValue__-fFw-"};